module.exports = "<span class=js-anchor> <span class=\"js-text member-text\"> {{#with member}} {{name}} {{else}} <span class=member-text__empty>{{localize 'CORE.FORM.EDITORS.MEMBERSELECT.NOTSET'}}</span> {{/with}} </span> </span> <div class=svg-icons-wrp> <div class=svg-icons-wrp__empty> <svg class=\"svg-icons svg-icons_member\"><use xlink:href=#icon-member /> </svg> </div> <div class=\"js-clear-button svg-icons-wrp__remove\"> <svg class=\"svg-icons svg-icons_remove\"><use xlink:href=#icon-remove /> </svg> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/memberSelect/templates/defaultButton.hbs
// module id = 664
// module chunks = 0